import React from 'react';

import AppBar from 'components/AppBar';
import ModalHeader from 'components/ModalHeader';
import { Desktop, Mobile } from 'components/Responsive';
import PaymentCardNoCard from 'screens/components/Payment/PaymentCardNoCard';

interface Props {
  title: string;
  onClose: () => void;
}

const PaymentHelp = ({ title, onClose }: Props) => (
  <>
    <Mobile>
      <AppBar goBack={onClose}>
        <h5>{title}</h5>
      </AppBar>
    </Mobile>

    <Desktop>
      <ModalHeader title={title} onClose={onClose} />
    </Desktop>
    <PaymentCardNoCard onClick={() => {}} noButton={true} />
  </>
);

export default PaymentHelp;
